














import {
  Vue,
  Component
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: {
    Button
  }
})
export default class AdminDemoUsersReport extends Vue {
  userStore = useUserStore();

  downloadCsv () {
    this.userStore.downloadDemoUsersReport();
  }
}
